module.exports = __webpack_public_path__ + "static/media/programa_publico_daniel_aguilar.b73ac66e.jpg";